import { useQuery } from '@tanstack/react-query';

import type { ApiClientError } from '@/lib/api-client';
import { fetchReclassifiedReceipts } from './api';
import type { ReclassifiedReceiptDto } from './types';

const KEY = 'reclassified-receipts' as const;

/** Disassembly-batch-scoped list of reclassified receipts. */
export const useReclassifiedReceipts = (disassemblyBatchId: string | undefined) => {
  return useQuery<ReclassifiedReceiptDto[], ApiClientError>({
    queryKey: [KEY, 'list', disassemblyBatchId],
    queryFn: () => fetchReclassifiedReceipts(disassemblyBatchId!),
    enabled: !!disassemblyBatchId,
    placeholderData: (prev) => prev,
  });
};
